import { http } from '../config/config-receituario'
export default {
    listar: async (token, filters = {}) => {
        return http.get('estoques/filter', {
            headers: {
                'Authorization': token
            },
            params: filters
        })
    },
    findAllByProduct: async (token, id) => {
        return http.get(`estoques/produtos/${id}`, {
            headers: {
                'Authorization': token
            }
        })
    },
    findAllByDate: async (token, dtInicial, dtFinal, produto, receita, nf) => {
        return http.get('estoques/filter', {
            headers: {
                'Authorization': token
            },
            params: {
                data_inicial: dtInicial || undefined,
                data_final: dtFinal || undefined,
                produto: produto || undefined,
                receita: receita || undefined,
                nf: nf || undefined,
            }
        })
    },
    baixaReceituario: async (token, id) => {
        return http.get(`estoques/baixa/receita/${id}`, {
            headers: {
                'Authorization': token
            }
        })
    },
    altaEstoqueReceituario: async (token, id) => {
        return http.get(`estoques/alta/receita/${id}`, {
            headers: {
                'Authorization': token
            }
        })
    },
    salvar: (token, estoque) => {
        return http.post('estoques', estoque, {
            headers: {
                'Authorization': token
            }
        })
    },
    deletar: (token, id) => {
        return http.delete(`estoques/${id}`, {
            headers: {
                'Authorization': token
            }
        })
    },
    update: (token, estoque) => {
        return http.put(`estoques/${estoque.id}`, estoque, {
            headers: {
                'Authorization': token
            }
        })
    }

}
